// Descending sorting isn't used, but available from backend

export enum sortByType {
  APPROVAL_DATE_DESCENDING = '1',
  ALPHABETICALLY_DESCENDING = '2',
}
